// Service for employee profile GET operations
import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type { EmployeeProfile, LC_GetEmployeeProfileOut } from '../types';
import { mapEmployeeProfileOutToModel } from '../mappers';
import { geographyService, type Region, type Commune } from '../../geography';
import { maritalStatusService, type MaritalStatus } from '../../catalog/maritalStatus';


export class EmployeeGetService {
  async getProfile(employeeId: number): Promise<ApiResponse<EmployeeProfile>> {
    if (import.meta.env.VITE_API_DEBUG === 'true') {
      // eslint-disable-next-line no-console
      console.debug(
        '[employeeGetService.getProfile] GET',
        API_CONFIG.ENDPOINTS.EMPLOYEES.PROFILE(employeeId),
      );
    }
    const response = await apiClient.get<LC_GetEmployeeProfileOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEES.PROFILE(employeeId),
    );
    if (!response.success || !response.data) return { ...response, data: null };
    try {
      const mapped = mapEmployeeProfileOutToModel(response.data);
      return { ...response, data: mapped };
    } catch {
      return { ...response, data: null, success: false };
    }
  }

  async getRegions(country: string): Promise<ApiResponse<Region[]>> {
    return geographyService.getRegions(country);
  }

  async getCommunes(country: string, regionId: number): Promise<ApiResponse<Commune[]>> {
    return geographyService.getCommunes(country, regionId);
  }

  async getMaritalStatuses(countryId: number): Promise<ApiResponse<MaritalStatus[]>> {
    return maritalStatusService.getMaritalStatuses(countryId);
  }
}

export const employeeGet = new EmployeeGetService();
